<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 100%;
  background: url('../../../../../assets/img/trp/left2.png');
  background-size: 100% 100%;
  overflow: hidden;

  .title {
    height: 20px;
    font-size: 20px;
    line-height: 40px;
    width: 100%;
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(254, 254, 254, 1);
  }

  .swiper-wrap {
    margin-top: 50px;
    width: 92%;
    height: 317px;
    // border: 1px solid #FFF;
  }

  .swiper-slide {
    height: 36px;
  }

  .list {
    color: #fff;
    margin-top: 25px;
    margin-left: 10px;

    // border: 1px solid #FFF;
    .list-item {
      // height: 36px;
      // line-height: 36px;
      height: 50px;
      line-height: 17px;

      .name {
        color: #FFF;
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }

      .length {
        margin-right: 10px;
        float: left;
        margin-top: 14px;
        width: 95%;
        height: 3px;
        background: rgba(13, 58, 148, 1);

        // border-radius: 5px;
        .active {
          height: 8px;
          background: #006CFF;
          margin-top: -5px;
        }
      }

      .num {
        font-size: 16px;
        float: right;
        width: 21%;
      }
    }

    .list-item .length .cur {
      background: linear-gradient(to right, #fcc94a, #ff8700) !important; /* 标准的语法 */
    }

    .list-item .length .cur1 {
      background: linear-gradient(to right, #c0e450, #75cd2d) !important; /* 标准的语法 */
    }

    .list-item .length .cur2 {
      background: linear-gradient(to right, #5eb5ff, #217dfb) !important; /* 标准的语法 */
    }

    .list-item:nth-child(1) .length .active {
      width: 90%;
      background: #006CFF;
      // border-radius: 5px;
    }

    .list-item:nth-child(2) .length .active {
      // width: 70%;
      background: linear-gradient(90deg, #fcc94a, #ff8700);
    }

    .list-item:nth-child(3) .length .active {
      // width: 60%;
      background: linear-gradient(90deg, #C0E450, #75CD2D);
    }

    .list-item:nth-child(4) .length .active {
      // width: 50%;
      background: linear-gradient(90deg, #c0e450, #75cd2d); /* 标准的语法 */
    }

    .list-item:nth-child(5) .length .active {
      // width: 40%;
      background: linear-gradient(90deg, #5eb5ff, #217dfb); /* 标准的语法 */
    }
  }
}
</style>

<template>
  <!-- <boxWrap :name="name" :min="true"> -->
  <div class="bar-wrap">
    <div class="title">经营主体交易排行榜</div>
    <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="tableData.length != 0">
      <template v-if="tableData.length > 3">
        <swiper-slide v-for="(item, index) in tableData" :key="index" class="list">
          <div class="list-item">
            <div class="num">{{ item.productionForecast }}笔</div>
            <div class="name">{{ item.id }}</div>
            <div class="length">
              <div class="active" :class="cla(index)" :style="`width:${(item.productionForecast / sum) * 100}%`"></div>
            </div>
          </div>
        </swiper-slide>
      </template>
      <template v-else>
        <div v-for="(item, index) in tableData" :key="index" class="list">
          <div class="list-item">
            <div class="name">{{ item.id }}</div>
            <div class="length">
              <div class="active" :class="cla(index)" :style="`width:${(item.productionForecast / sum) * 100}%`"></div>
            </div>
            <div class="num">{{ item.productionForecast }}分</div>
          </div>
        </div>
      </template>
    </swiper>
  </div>
  <!-- </boxWrap> -->
</template>

<script>
import boxWrap from '../common/boxWrap';
import bar from 'components/dashboard/bar'
import echarts from "echarts";

import '@/assets/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '垃圾分类积分排行',
      tableData: [],
      sum: 0,
      swiperOption: {
        slidesPerView: 'auto',
        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
    cla(index) {
      if (index === 1) {
        return 'cur'
      }
      if (index === 2) {
        return 'cur1'
      }
      if (index === 3) {
        return 'cur2'
      }
    }
  },
  async mounted() {
    // const data = ['鹿邑县张万里农资门市部', '鹿邑县钻草农资经营门市部', '鹿邑县绍游农资商店', '鹿邑县星灿农业农村服务']
    //   .map(x => ({
    //     id: x,
    //     productionForecast: Math.round(Math.random() * 10000 + 200)
    //   }))
    this.tableData = [
      { id: '鹿邑县张万里农资门市部', productionForecast: 10000 },
      { id: '鹿邑县钻草农资经营门市部', productionForecast: 8888 },
      { id: '鹿邑县绍游农资商店', productionForecast: 7777 },
      { id: '鹿邑县星灿农业农村服务', productionForecast: 6666 },
      { id: '鹿邑县张永明农资批零部', productionForecast: 5555 }
    ]
    this.sum = 10000
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?0f8f7324